module.exports = __webpack_public_path__ + "img/banner.849732f1.jpg";